import { Stack, Typography } from "@mui/material";

import PaymentItem from "./PaymentItem";

const BillingHistory = ({ data = [], refetch }: any) => (
  <Stack spacing={2}>
    <Stack
      flexDirection={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <Typography variant="h4" fontSize={16} fontWeight={600} color="#707070">
        HISTÓRICO DE COBRANÇAS
      </Typography>
    </Stack>
    <Stack spacing={1}>
      <PaymentItem data={data} refetch={refetch} tags />
    </Stack>
  </Stack>
);

export default BillingHistory;
